exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-content {\n  position: absolute;\n  width: 100%;\n  margin-top: 5px;\n  background: #fff;\n  z-index: 999;\n}\n", ""]);

// exports
